/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaHome, FaWrench } from "react-icons/fa";
import "./Sidebar.css";
import { FaNoteSticky } from "react-icons/fa6";
import { IoMdContact } from "react-icons/io";


const Sidebar = ({ type }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const menus = {
    
    headoffice: [
      {
        path: "/dashboard-headoffice/",
        label: "Dashboard",
        icon: <FaHome />,
      },
      {
        path: "/dashboard-headoffice/claim",
        label: "Pelaporan Klaim",
        icon: <FaNoteSticky />,
      },
      {
        path: "/dashboard-headoffice/bengkel",
        label: "Bengkel",
        icon: <FaWrench />,
      },
    ],
    insured: [
      {
        path: "/dashboard-insured/bengkel",
        label: "Bengkel",
        icon: <FaWrench />,
      },
      {
        path: "/dashboard-insured/klaim",
        label: "Monitoring Klaim",
        icon: <FaNoteSticky />,
      },
    ],
    workshop: [
      {
        path: "/dashboard-workshop/",
        label: "Dashboard",
        icon: <FaHome />,
      },
      {
        path: "/dashboard-workshop/klaim",
        label: "Daftar Klaim",
        icon: <FaNoteSticky />,
      },
      {
        path: "/dashboard-workshop/profile",
        label: "Profil",
        icon: <IoMdContact />,
      },
    ],
    branchoffice: [
      {
        path: "/dashboard-branch/",
        label: "Dashboard",
        icon: <FaHome />,
      },
      {
        path: "/dashboard-branch/claim",
        label: "Pelaporan Klaim",
        icon: <FaNoteSticky />,
      },
      {
        path: "/dashboard-branch/administrator",
        label: "User Administrator",
        icon: <IoMdContact />,
      },
      {
        path: "/dashboard-branch/bengkel",
        label: "Bengkel",
        icon: <FaWrench />,
      },
    ],  
  };

  const menuItems = menus[type] || [];
  const roleLabels = {
    headoffice: "Head Office",
    branchoffice: "Branch Office",
    insured: "Tertanggung",
    workshop: "Bengkel",
  };
  const isMenuActive = (path) => {
    const normalizedPath = path.endsWith("/") ? path.slice(0, -1) : path;
    return location.pathname === normalizedPath ||
      (!path.endsWith("/") && location.pathname.startsWith(`${normalizedPath}/`));
  };

  return (
    <>
      <button type="button" className="hamburger" aria-label="Buka menu navigasi" aria-expanded={isOpen} onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      <button type="button" className={`sidebar-backdrop ${isOpen ? "open" : ""}`} aria-label="Tutup menu navigasi" onClick={() => setIsOpen(false)} />

      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-brand">
          <strong>JASTAN CLAIM</strong>
          <span>{roleLabels[type] || "Portal Klaim"}</span>
        </div>
        <nav aria-label="Navigasi utama">
          <ul className="menu">
          {menuItems.map((menu) => (
            <Link key={menu.path} to={menu.path} onClick={() => setIsOpen(false)}>
              <li
                className={`menu-item ${isMenuActive(menu.path) ? "active" : ""}`}
              >
                <span className="menu-icon">{menu.icon}</span>
                {menu.label}
              </li>
            </Link>
          ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
